import { Link } from "react-router-dom";

export function PageHeader({
  overline,
  title,
  lead,
  testId = "page-header",
  backgroundImage,
}) {
  if (backgroundImage) {
    return (
      <section
        data-testid={testId}
        className="relative overflow-hidden border-b border-slate-200"
      >
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${backgroundImage})` }}
          aria-hidden="true"
        />
        <div
          className="absolute inset-0 bg-gradient-to-br from-[#0B1A3D]/85 via-[#0B1A3D]/70 to-[#0B1A3D]/60"
          aria-hidden="true"
        />
        <div className="relative container-mtbl py-28 md:py-36">
          {overline && (
            <p className="text-[10px] md:text-xs font-bold uppercase tracking-[0.3em] text-white/80 mb-6">
              {overline}
            </p>
          )}
          <h1 className="text-white text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.05] max-w-4xl">
            {title}
          </h1>
          {lead && (
            <p className="mt-8 text-white/90 text-lg md:text-xl leading-relaxed max-w-3xl">
              {lead}
            </p>
          )}
        </div>
      </section>
    );
  }

  return (
    <section
      data-testid={testId}
      className="relative overflow-hidden border-b border-slate-200 bg-paper"
    >
      <div className="container-mtbl py-24 md:py-32">
        {overline && <p className="overline mb-6">{overline}</p>}
        <h1 className="text-[#0B1A3D] text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.05] max-w-4xl">
          {title}
        </h1>
        {lead && (
          <p className="mt-8 text-slate-600 text-lg md:text-xl leading-relaxed max-w-3xl">
            {lead}
          </p>
        )}
      </div>
    </section>
  );
}

export function SectionHeader({ overline, title, lead, align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "";
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {overline && <p className="overline mb-5">{overline}</p>}
      <h2 className="text-[#0B1A3D] text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight">
        {title}
      </h2>
      {lead && (
        <p className="mt-6 text-slate-600 text-base md:text-lg leading-relaxed">
          {lead}
        </p>
      )}
    </div>
  );
}

export function PrimaryLink({ to, children, testId, external = false }) {
  if (external) {
    return (
      <a href={to} data-testid={testId} className="btn-primary">
        {children}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testId} className="btn-primary">
      {children}
    </Link>
  );
}

export function SecondaryLink({ to, children, testId }) {
  return (
    <Link to={to} data-testid={testId} className="btn-secondary">
      {children}
    </Link>
  );
}

export function Disclaimer({ children, testId = "disclaimer" }) {
  return (
    <p
      data-testid={testId}
      className="mt-10 border-l-2 border-slate-300 pl-5 text-xs md:text-sm text-slate-500 max-w-3xl leading-relaxed"
    >
      {children}
    </p>
  );
}
